import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { ReleaseNote } from 'src/app/models/release-note';
import * as releaseNotesActions from './release-note.actions';

export interface ReleaseNoteState extends EntityState<ReleaseNote> {
  loadingReleases: boolean;
  releasesLoaded: boolean;
}

export const releaseNoteAdapter: EntityAdapter<ReleaseNote> = createEntityAdapter<ReleaseNote>({});

export const initialReleaseNoteState: ReleaseNoteState = releaseNoteAdapter.getInitialState({
  loadingReleases: false,
  releasesLoaded: false,
});

export const reducer = createReducer(
  initialReleaseNoteState,
  on(releaseNotesActions.getReleaseNotes, (state) => {
    return releaseNoteAdapter.removeAll({
      ...state,
      loadingReleases: true,
      releasesLoaded: false,
    });
  }),
  on(releaseNotesActions.getReleaseNotesSuccess, (state, { releaseNotes }) => {
    return releaseNoteAdapter.setAll(releaseNotes, {
      ...state,
      loadingReleases: false,
      releasesLoaded: true,
    });
  }),
  on(releaseNotesActions.getReleaseNotesError, (state) => {
    return {
      ...state,
      loadingReleases: false,
      releasesLoaded: false,
    };
  }),
  on(releaseNotesActions.deleteReleaseNoteSuccess, (state, { deletedReleaseNoteId }) => {
    return releaseNoteAdapter.removeOne(deletedReleaseNoteId, {
      ...state,
    });
  }),
  on(releaseNotesActions.editReleaseNoteSuccess, (state, { editedReleaseNote }) => {
    return releaseNoteAdapter.updateOne(
      { changes: editedReleaseNote, id: editedReleaseNote.id },
      {
        ...state,
      }
    );
  })
);

export function releaseNoteReducer(state: ReleaseNoteState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = releaseNoteAdapter.getSelectors();
